import jwt_decode from "jwt-decode";
import { AUTHORIZATION_HEADER } from "./base-axios.service";
import LoginService from "./login.service";
import { Auth, JWTData } from "shared/models/auth.model";

export const TOKEN_KEY = "user-parceiro";

export class User {

    private loginService: LoginService = new LoginService();

    setAuth(auth){
        localStorage.setItem(TOKEN_KEY, JSON.stringify(auth));
    }

    getToken(): string {
        return this.getAuth() ? this.getAuth().accessToken : null
    };
    
    getTokenDecode(): JWTData {
        return this.getAuth() ? jwt_decode(this.getAuth().accessToken) : null;
    };

    getAuth(): Auth {
        return localStorage.getItem(TOKEN_KEY) ? JSON.parse(localStorage.getItem(TOKEN_KEY)) : null;
    };

    getGrups(){
        return this.getTokenDecode().groups
    }

    getRefreshToken(): string {
        return this.getAuth().refreshToken
    };
    
    getExpireToken(): Date {
        if(this.getTokenDecode() == null)
            return null;

        return new Date(this.getTokenDecode().exp * 1000);
    }
    isAuthenticated(): boolean {
        return localStorage.getItem(TOKEN_KEY) !== null;
    }

    isParceiro(): boolean {
        if(this.getTokenDecode() == null)
            return false;

        return this.getTokenDecode().partnerId !== -999999999;
    }
    
    getNomeUsuario(): string {
        let decoded: any = this.getTokenDecode();

        if (decoded == null)
            return "";
        else
            return decoded.name;
    }

    isPrimeiroAcesso(): boolean {
        return this.getAuth() ? this.getAuth().passwordReseted : false;
    }

    logout() {
        localStorage.removeItem(TOKEN_KEY);
    }

    login(token): Promise<boolean> {
        return Promise.resolve().then(() => {
            localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
            return JSON.parse(localStorage.getItem(TOKEN_KEY)).passwordReseted;
        });
    };

    refreshToken = (): void => {
        if(this.getAuth()){
            let objeto = {
                grantType: "refresh_token",
                refreshToken: this.getAuth().refreshToken,
            };
    
            let headers = {
                [AUTHORIZATION_HEADER]: this.getAuth().accessToken,
            };
    
            this.loginService
                .postLogin(objeto, headers)
                .then((result) => {
                    if (result.status === 200) {
                        localStorage.setItem(
                            TOKEN_KEY,
                            JSON.stringify(result.data)
                        );
                    }
                })
                .catch((erro) => {
                    console.log(erro);
                });
        }
       
    };
}
